import { Stack } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useContext, useMemo, useState } from "react";
import { WorkspaceContext } from "../../../contexts/WorkspaceContext";
import useDashboards from "../../../hooks/useDashboards";
import { Workspace } from "../../../types/files";
import DashboardsTableFilter from "../../molecules/dashboards-table/DashboardsTableFilter";
import SharedByAll from "../../molecules/workspaces/SharedByAll";
// import SharedByMeV2 from "../../molecules/workspaces/SharedByMeV2";
import { FallbackLoading } from "../../templates/loader";
import DashboardsTableProvider from "../../../contexts/TablesContext/DashboardsTableProvider";

export enum SharedBy {
    All = 'All',
    Me = 'Me',
}

const useStyles = makeStyles((theme) => ({
    panel: {
        height: '100%',
        width: '100%',
        transition: 'width .3s ease',
        overflow: 'hidden',
    },
    expanded: {
        height: '100%',
        width: '100%',
        minWidth: 'calc(100vw - 94px - 156px)',
        maxWidth: '100%',
    },
    preferences: {
        overflow: 'hidden',
        zIndex: 1300,
    },
    tabPanel: {
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        padding: 'unset',
    },
    title: {
        fontFamily: 'Inter',
        fontSize: '1.75rem',
        fontWeight: 'bold',
        color: theme.colors.neutral['800'],
    },
    selectorForm: {
        minWidth: 'unset',
        width: 'fit-content',
        height: 'auto',
        padding: 0,
        border: 0,
        "& > .MuiInputBase-root":{
            "& > .MuiSelect-select": {
                paddingLeft: 6,
            },
            "& > .MuiSvgIcon-root": {
                width: 24,
                height: 24,
                fill: theme.colors.neutral['600'],
                '&.Mui-disabled': {
                    fill: 'rgba(0, 0, 0, 0.26)',
                },
            },
            "& fieldset": {
              border: 0,
            },
        },
    },
    menuItem: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 8,
    },
    menuLabel: {
        fontFamily: 'Inter',
        fontSize: '0.95rem',
        fontWeight: 600,
        color: theme.colors.neutral['600'],
    },
    menuSelected: {
        fontFamily: 'Inter',
        fontWeight: 700,
        color: theme.colors.primary['400'],
    },
}));

const InvestmentThesisV2: React.FC<{
    workspace?: Workspace,
    search?: string,
}> = ({ workspace, search }) => {
    const classes = useStyles();
    const { workspace: globalWorkspace } = useContext(WorkspaceContext);
    const { dashboardsLoaded } = useDashboards();
    const [count, setCount] = useState<number>(0);

    const localWorkspace = useMemo(() => workspace ?? globalWorkspace, [globalWorkspace, workspace]);

    if (!localWorkspace)
        return (<></>);

    return (<>
        {!dashboardsLoaded ? (
            <FallbackLoading height={`calc(100vh - 250px)`} />
        ) : (
            <Stack direction="column" className={classes.panel} alignItems="stretch" justifyContent="flex-start">
                <DashboardsTableProvider>
                    <DashboardsTableFilter count={count} />
                    <SharedByAll
                        workspace={localWorkspace}
                        search={search}
                        onCount={setCount} />
                </DashboardsTableProvider>
            </Stack>
        )}
    </>);
}

export default InvestmentThesisV2;
